import * as echarts from "echarts";

export const darkBg = "#13171f";
export const gridColor = "#1e2330";
export const labelColor = "#b0b8c4";

export function makeGradient(color) {
  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: color + "55" },
    { offset: 1, color: color + "05" },
  ]);
}

export const tooltipStyle = {
  backgroundColor: "#1e2330",
  borderColor: "#2a2f3d",
  textStyle: { color: "#e0e6f0", fontSize: 12 },
};
